import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { EndpointPathNames } from "@/shared/config/endpoint-path";
import { HELP_URL } from "@/shared/config/constants";
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";


export const Sidebar = () => {
  const navigate = useNavigate();
  // 選択中ルート
  const location = useLocation();
  const currentPath = location.pathname;
  const { setOpenHomeModal } = useModalContext();


  return (
    <nav className="nav_main_menu">
      <button
        type="button"
        className="btn-home"
        onClick={() => {
            if (!currentPath.startsWith("/home")) {
              navigate(EndpointPathNames.HOME)
            }
          }}
      >
        <span>ホーム</span>
      </button>

      <button
        type="button"
        className="btn-data"
        onClick={() => {
            if (!currentPath.startsWith("/mydata")) {
              navigate(EndpointPathNames.MYDATA)
            }
          }}
      >
        <span>グループ</span>
      </button>

      <button
        type="button"
        className="btn-help"
        onClick={() => {
          window.open(HELP_URL, "_blank", "noopener,noreferrer");
        }}
      >
        <span>ヘルプ</span>
      </button>

      <button
        type="button"
        className="open-modal btn-bell"
        onClick={() => {
          setOpenHomeModal("News");
        }}
      >
        <span>お知らせ</span>
      </button>
    </nav>
  );
};
